import React, {
  useEffect,
  useState,
} from 'react';

import { usersAPI } from 'api/usersAPI';
import SearchIcon from 'assets/images/icon/SearchIcon';
import { cloneDeep } from 'lodash';
import qs from 'qs';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import {
  Overlay,
  Pagenation,
} from 'view/components';
import CoPopup from 'view/pages/Members/components/CoPopup';
import ListItem from 'view/pages/Members/components/ListItem';
import ListItemTitle from 'view/pages/Members/components/ListItemTitle';
import AuthorProfile from "../../Profile/SubPage/AuthorProfile";
import InstructorPopup from "../components/InstructorPopup";

const testData = [
      {
          check: true,
          userName: "Daan Stanley",
          job: "Accountant",
          email: "Dean_Stanley@gmail.com",
          verified: true,
          status: "Approved",
          enrolled: "Jul 22,2023",
          updated: "Jul 22,2023",
      },
      {
          check: true,
          userName: "Daan Stanleyas",
          job: "Accountant",
          email: "Dean_Stanlasdey@gmail.com",
          verified: true,
          status: "Approved",
          enrolled: "Jul 22,2023",
          updated: "Jul 22,2023",
      },
      {
          check: true,
          userName: "Daan Stanley",
          job: "Accountant",
          email: "Dean_Stanley@gmail.com",
          verified: true,
          status: "Approved",
          enrolled: "Jul 22,2023",
          updated: "Jul 22,2023",
      },
      {
          check: true,
          userName: "Daan Stanley",
          job: "Accountant",
          email: "Dean_Stanley@gmail.com",
          verified: true,
          status: "Approved",
          enrolled: "Jul 22,2023",
          updated: "Jul 22,2023",
      },
      {
          check: true,
          userName: "Daan Stanley",
          job: "Accountant",
          email: "Dean_Stanlasdasdaey@gmail.com",
          verified: true,
          status: "Approved",
          enrolled: "Jul 22,2023",
          updated: "Jul 22,2023",
      },
  ];
  
  
  const Instructor = (props) => {
      const [renderItem, setRenderItem] = useState(false);  
      const [selectStatus, setSelectStatus] = useState("Submitted");
      const [count, setCount] = useState(0)
      const [listStatus ,setListStatus] = useState({
        APPROVED:0,
        PENDING:0,
        SUBMITTED:0
    })
      const [editId, setEditId] = useState(0)
      const [list, setList] = useState([]);
      const [idList, setIdList] = useState([]);
      const [popup, setPopup] = useState(false);
      const [pageInfo, setPageInfo] = useState({
          totalPages:0,
          number:0,
          size:5,
      })
  
      const getAppList = async (pageNumber) => {
          await usersAPI.getApplicantList({
              params:{
                  paged:true,
                  page:pageNumber,
                  size:5,
        //   joinStatus:String(selectStatus).toLocaleUpperCase() 
        joinStatus:"APPROVED"        
  
              }
          })
          .then(res => {
              console.log('app users', res)
              setList(res?.data?.content)
              setCount(res?.data?.totalElements)
              setPageInfo({
                  totalPages:res?.data?.totalPages,
                  number:res?.data?.number,
                  size:res?.data?.size
              })
          })
      };    
  
      const deleteById = async (id) => {
          await usersAPI.deleteInstructorById(id)
          .then(res => {
              console.log('delete', res)
              getAppList(pageInfo.number);  
          })
      }
  
      const statusArr = [
          {
              name:"Results",
              onClick:(status) => {setSelectStatus(status)},
              count:count
          },
        //   {
        //       name:"Pending",
        //       onClick:(status) => {setSelectStatus(status)}
        //   },
        //   {
        //       name:"Approved",
        //       onClick:(status) => {setSelectStatus(status)}
        //   },
      ];
  
      const onClickAddIndex = (id) => {
          const c = cloneDeep(idList);
          const check = c.findIndex(item => {
              return item === id;
          })
          if(check !== -1){
              c.splice(check,1);
          }else{
              c.push(id)
          }
          setIdList(c);
      };
  
      const onClickMovePage = (isNext) => {
          const c = cloneDeep(pageInfo);
          if(isNext){
              if(pageInfo?.number + 1 === pageInfo?.totalPages) return;
              c.number = c.number + 1
          }else{
              if(pageInfo?.number === 0) return;
              c.number = c.number - 1
          }
          setPageInfo(c);
      };
  
      const onClickAll = () => {
            if(!isEmpty(idList)){
              setIdList([]);
            }else{
              const m = cloneDeep(list)?.map(item => {
                  return item?.id
                });
      
                setIdList(m);
            }  
      }
  
      const deleteList = async () => {
          const data = qs.stringify(
              { ids: idList },
              { arrayFormat: 'repeat' }
            );
          await usersAPI.deleteInstructor(data)        
          .then(res => {
              getAppList(0);
          })
      };

      const getInstructorStatus = async () => {
        await usersAPI.getInstructorStatus({

        })
        .then(res => {
            setListStatus(res?.data)
        })
    }
      const onClickEdit = (id) => {
          setPopup(v => !v);
          setEditId(id);
      };
  
      useEffect(() => {
          getAppList(pageInfo.number);
      }, [pageInfo.number]);
  
      useEffect(()=>{
          getAppList(0);
      },[selectStatus]);

      useEffect(()=>{
        setTimeout(()=>{
            setRenderItem(true)
        },300)
      },[])

    useEffect(()=>{
        getInstructorStatus();
    },[])
  
      return (
          <Container className={renderItem ? "on" : ""} >
              {
                  popup === true && 
                  <Overlay filter={false}>
                  <InstructorPopup id={editId} onClickPopup={()=> {setPopup(v => !v)}} />
              </Overlay>
              }
              
              <ContentsInner>                
                  <SearchArea>
                      <TopContents>
                      <InputArea>
                          <input type="text" placeholder="Search.." />
                          <div>
                              <SearchIcon />
                              <span>Search</span>
                          </div>                        
                      </InputArea>
                      <DeleteButton>
                          <span
                              onClick={async ()=>{
                                  await deleteList()
                              }}
                          >Delete Selection</span>
                      </DeleteButton>    
  
                      </TopContents>
                      
                      <TabList>
                          {
                              statusArr.map(item => {
                                  return(
                                      <span 
                                      className={"on"}
                                      onClick={()=>{item.onClick(item.name)}} >{item.name} : {item?.count}</span>
                                  )
                              })
                          }
                  </TabList>
                  </SearchArea>
             
                  <Wrap>
                      <ListItemTitle onClickCheckbox={onClickAll} checkState={!isEmpty(idList) && idList.length === list.length} />
                      {
                      !isEmpty(list) ?
                      list?.map((item) => {
                          return <ListItem
                          onClickAddIndex={onClickAddIndex}
                          onClickEdit={onClickEdit}
                          idList={idList}
                          onClickDelete={deleteById} data={item} />;
                      })
                      :
                      ""
                  }
                  </Wrap>
  
                  <Pagenation totalPage={pageInfo?.totalPages} 
                  onClickMove={(isNext)=>{onClickMovePage(isNext)}}
                  size={pageInfo?.size} pageNumber={pageInfo?.number} />
              </ContentsInner>
          </Container>
      );
  };
  export default Instructor;
  
  const Container = styled.div`
      height: 100%;
      position: relative;
      padding: 20px;
      opacity: 0;
      transition: all 0.3s;
      transform: translateY(30px);
      height: 300px;
      &.on{
        height: auto;
        opacity: 1;
        transform: none;
      }
  `;
  
  const ContentsInner = styled.div`
      overflow: hidden;
      position: relative;
      height: 100%;
      border: solid 0.6px #33333358;
      border-radius: 8px;
  `;
  
  const Wrap = styled.div`
      scrollbar-width: thin;
      scrollbar-color: transparent transparent;
      width: 100%;
      overflow-x: auto;
      &::-webkit-scrollbar {
          width: 1px;
          height: 10px;
      }
      &::-webkit-scrollbar-thumb {
          background-color: rgba(51, 51, 51, 0.3);
          border: none;
          border-radius: 5px;
      }
      &::-webkit-scrollbar-track {
          background-color: transparent;
          border: none;
      }
  `;
  
  const SearchArea = styled.div`
      padding: 20px 20px 10px 20px;
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: space-between;
      border-bottom: solid 0.6px #3333334D;
  `;
  const TopContents = styled.div`
    display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      margin-bottom: 30px;
  `; 
  const ListArea = styled.div``;
  
  const InputArea = styled.div`
      width: 50%;
      display: flex;
      max-width: 332px;
      height: 40px;
      border-radius: 8px;
      overflow: hidden;
      align-items: center;
      flex-direction: row;
  
      div {
          height: 100%;
          box-sizing: border-box;
          padding: 0 8px;
     background-color: #FCC922;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          svg {
              padding-bottom: 3px;
          }
          span {
              font-weight: 700;
              font-size: 16px;
              margin-left: 8px;
              
          }
      }
      input {
          padding-left: 15px;
          outline: none;
          display: flex;
          height: 100%;
          width: 100%;
          flex: 1;
          border-radius: 8px 0 0 8px;
          border: solid 1px #e5e5e5;
          border-right: none;
          &::placeholder {
              opacity: 0.5;
          }
      }
  `;
  const DeleteButton = styled.div`
      span{
          cursor: pointer;
          height: 40px;
          border-radius: 6px;
          font-size: 14px;
          line-height: 20px;
          display: flex;
          align-items: center;
          padding: 0 12px;
          background: #EB5757;
          color: #fff;
          justify-content: center;
      }
  `; 
  
  const TabList = styled.div`
      display: flex;
      flex-direction: row;
      align-items: center;
      transition: all 0.2s;
      span{
      transition: all 0.2s;
  
          cursor: pointer;
          &.on{
              color:#333;
              border-bottom: solid 2px #333;
          }
          border-bottom: solid 2px #ffffff;
          display: flex;
          margin-right: 20px;
          font-family: Europa-Regular;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
          color: #33333399;
      }
  `; 
  const Tab = styled.div`
      
  `; 